import React, { Component } from 'react';
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import Carousel from 'fade-carousel';

const divStyle = {
    height: "100%",
    width: "100%"
}
const imageStyle = {
    height: '100%',
    width: '100%',
    justifySelf: 'center'
}

export class MobileSuperFilm extends Component {
    static displayName = "MobileSuperFilm";

    constructor(props) {
        super(props);

        this.launchTrailer = this.launchTrailer.bind(this);
        this.handler = this.handler.bind(this);
        this.populateSuperfilmContents = this.populateSuperfilmContents.bind(this);        

        this.state = {
            collapsed: true,
            superFilmContents: [],
            loadingSuperFilmContents: true,
            startedLoadingSuperFilmContents: true 
        };
    }

    async populateSuperfilmContents() {
        if (this.state.startedLoadingSuperFilmContents) {
            this.setState({ startedLoadingSuperFilmContents: false });
            const response = await fetch('api/home/getsuperfilmcontents?cityCode=' + this.props.cityCode);
            const data = await response.json();
            //console.log(data);
            this.setState({ superfilmContents: data, loadingSuperFilmContents: false });
        }
    }

    async componentDidMount() {
        await this.populateSuperfilmContents();
    }

    launchTrailer(filmTrailerURL) {
        this.props.launchTrailer(filmTrailerURL);
    }

    handler() {
        this.props.handler();
    }
    
    render() {
        
        if (this.state.loadingSuperFilmContents) {
            return <div>Laddar...</div>
        }

        if (!this.state.loadingSuperFilmContents && (this.state.superfilmContents.superFilmID===null)) {
            return <div></div>
        }
        
        return (
            <Carousel divStyle={divStyle} delay={5000} mode={"fade"} >
                {this.state.superfilmContents.map((url, index) => (
                    <div key={index} style={imageStyle}>
                        <img
                            src={'https://www.eurostar.se/Images/Superfilm/' + url.superFilmImage}
                            style={{ width: "100%", height: "100%" }}
                        />
                        <div className="text-center">
                            <Link to={url.superFilmURL}>
                                <Button color="secondary" className="jumbotronbtn">L&#228;s mer/Boka biljett</Button>
                            </Link>
                            {url.superFilmTrailer.length > 0 ? <Button className="btn-default" onClick={() => this.launchTrailer(url.superFilmTrailerURL)}>Se Trailer</Button> : "" }
                        </div>
                    </div>
                ))}
            </Carousel>
        );
    }    
}
export default MobileSuperFilm;